import React from 'react'
import { Avatar, Item, Layout } from '@revolut/ui-kit'

import { cdnLink } from 'helpers/cdn'
import { isSandbox } from 'helpers/environment'

export const shouldShowPersonalAccountLink = () => {
  // Sandbox env is used for e2e tests with external parties,
  // so we're showing the old version in this case for now.
  return !isSandbox()
}

type PersonalAccountLinkProps = {
  href: string
}

export const PersonalAccountLink = ({ href }: PersonalAccountLinkProps) => (
  <Item variant='disclosure' use='a' href={href}>
    <Item.Avatar>
      <Avatar
        variant='app'
        image={cdnLink('business/connect/revolut/revolut10_white.png')}
      />
    </Item.Avatar>

    <Item.Content>
      <Item.Title>Switch to Personal account</Item.Title>
      <Item.Description>Continue in Revolut</Item.Description>
    </Item.Content>

    <Layout.ActionsFill />
  </Item>
)
